<template>
  <v-footer class="elson-footer" padless>
    <v-container class="footer-wrap py-10">
      <v-row align="start">
        <v-col cols="12" md="4">
          <span class="brand">ELSONIII</span>
          <p class="desc mt-3">
            ห้างหุ้นส่วนจำกัด เชียงรายมหานคร<br />
            ที่อยู่: 1 อาคารเอ็มไพร์ ทาวเวอร์ ชั้นที่ 47 ยูนิต 4703<br />
            ถนนสาทรใต้ แขวงยานนาวา เขตสาทร กรุงเทพฯ 10120<br />
            เบอร์โทร: <a href="tel:021198493" class="link-accent">02-119-8493</a><br />
            อีเมล: <a href="mailto:korakot.cr.train@gmail.com" class="link-accent">korakot.cr.train@gmail.com</a>
          </p>
        </v-col>

        <v-col cols="12" sm="6" md="2">
          <h3 class="col-title">เมนู</h3>
          <ul class="links">
            <li><a href="#" class="link">หน้าแรก</a></li>
            <li><a href="#" class="link">กระดานข่าว</a></li>
            <li><a href="#" class="link">ตลาดชุมชน</a></li>
            <li><a href="#" class="link">เปิดร้านค้า</a></li>
            <li><a href="#" class="link">เกี่ยวกับเรา</a></li>
          </ul>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <h3 class="col-title">บริการของเรา</h3>
          <ul class="links">
            <li><a href="#" class="link">สินค้าเดลิเวอรี่</a></li>
            <li><a href="#" class="link">โปรโมชั่นพิเศษ</a></li>
            <li><a href="#" class="link">ศูนย์ช่วยเหลือ</a></li>
            <li><a href="#" class="link">คำถามที่พบบ่อย</a></li>
            <li><a href="#" class="link">ติดต่อเรา</a></li>
          </ul>
        </v-col>

        <v-col cols="12" md="3">
          <h3 class="col-title">ติดตามเรา</h3>
          <div class="socials mt-3">
            <a href="#" class="social" aria-label="Facebook"><v-icon size="20">mdi-facebook</v-icon></a>
            <a href="#" class="social" aria-label="Instagram"><v-icon size="20">mdi-instagram</v-icon></a>
            <a href="#" class="social" aria-label="YouTube"><v-icon size="20">mdi-youtube</v-icon></a>
          </div>
        </v-col>
      </v-row>

      <v-divider class="foot-divider my-8" />

      <v-row align="center" justify="space-between" class="legal">
        <span class="legal-copy">© {{ new Date().getFullYear() }} ELSONIII — สงวนลิขสิทธิ์</span>
        <div class="legal-links">
          <router-link to="/" class="link">นโยบายความเป็นส่วนตัว</router-link>
          <span class="dot">•</span>
          <router-link to="/" class="link">ข้อกำหนดการใช้งาน</router-link>
        </div>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default { name: "Footer" };
</script>

<style scoped>
/* accent green — emerald ที่ balance กับส้มได้ดี */
:root { --green: #3DBE7A; }

.elson-footer {
  background: #F4811F !important;
  color: #ffffff;
}
.footer-wrap {
  max-width: min(1440px, 90vw);
  margin: 0 auto;
  font-family: "Noto Sans Thai", sans-serif;
  padding-inline: clamp(24px, 4vw, 64px);
}
.footer-wrap :deep(.v-row) {
  row-gap: 32px;
}

/* Brand — ขาว + เส้นเขียวขีดใต้ให้รู้สึก "มีเอกลักษณ์" */
.brand {
  font-size: clamp(22px, 1.6vw, 26px);
  font-weight: 800;
  color: #ffffff;
  font-family: "Kanit", "Noto Sans Thai", sans-serif;
  letter-spacing: 1px;
  display: inline-block;
  padding-bottom: 6px;
  border-bottom: 3px solid #3DBE7A;
}

/* Description */
.desc {
  color: rgba(255, 255, 255, 0.85);
  font-size: 13.5px;
  line-height: 1.9;
}

/* Accent links (phone, email) */
.link-accent {
  color: #ffffff;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.2s;
}
.link-accent:hover {
  color: #3DBE7A;
  text-decoration: underline;
}

/* Column titles — ขาว + เส้นเขียวด้านซ้ายเป็น visual marker */
.col-title {
  font-size: 13px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 14px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-family: "Noto Sans Thai", Arial, sans-serif;
  padding-left: 10px;
  border-left: 3px solid #3DBE7A;
}

/* Nav links */
.links {
  list-style: none;
  padding: 0;
  margin: 0;
}
.links li {
  margin-bottom: 10px;
}
.link {
  color: rgba(255, 255, 255, 0.8);
  font-size: 13.5px;
  text-decoration: none;
  transition: color 0.2s;
}
.link:hover {
  color: #3DBE7A;
}

/* Social icons — กรอบขาว hover เป็นเขียวเต็ม */
.socials {
  display: flex;
  gap: 10px;
}
.social {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  border: 1.5px solid rgba(255, 255, 255, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  transition: all 0.22s ease;
  text-decoration: none;
}
.social:hover {
  background: #3DBE7A;
  border-color: #3DBE7A;
  color: #ffffff;
  transform: translateY(-2px);
}
.social :deep(.v-icon) {
  color: inherit !important;
}

/* Divider */
.foot-divider {
  border-color: rgba(255, 255, 255, 0.2) !important;
}

/* Legal bar */
.legal {
  width: 100%;
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.65);
  flex-wrap: wrap;
  row-gap: 8px;
}
.legal-links {
  display: flex;
  align-items: center;
  gap: 10px;
}
.dot {
  color: rgba(255, 255, 255, 0.35);
}
.legal-copy {
  font-family: "Kanit", "Noto Sans Thai", sans-serif;
}

@media (max-width: 1440px) {
  .footer-wrap {
    max-width: 1200px;
    padding-inline: clamp(16px, 4vw, 40px);
  }
}
@media (max-width: 960px) {
  .legal {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
}
@media (max-width: 600px) {
  .brand {
    font-size: 20px;
  }
  .desc {
    font-size: 13px;
  }
}
</style>
